<template>
  <div class="dock" v-if="!userAgent">
    <div class="M-title">MIXIETAI·MALL</div>
    <div class="S-title">觅蟹台大闸蟹·商城</div>
    <div class="d-title">
      <el-radio-group v-model="tabPosition" @change="tapShow">
        <el-radio-button one label="left">精品三对装</el-radio-button>
        <el-radio-button two label="middle">豪华四对装</el-radio-button>
        <el-radio-button three label="right">至尊五对装</el-radio-button>
      </el-radio-group>
    </div>
    <!--三对装-->
    <div v-show="oneShow">
      <!-- 礼卡装 -->
      <div class="j-flex">
        <div class="j-left">
          <img src="@/assets/images/lika.png" alt />
          <div class="icon">礼卡装</div>
        </div>
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data1" :key="item.id">
              <div class="f-flex">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 礼盒装 -->
      <div class="j-flex" style="margin-top:0.5rem">
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data0" :key="item.id">
              <div class="f-flex">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="j-lihe">
          <img src="@/assets/images/lihe1.png" alt />
          <div class="icon">礼盒装</div>
        </div>
      </div>
    </div>
    <!-- 四对装 -->
    <div v-show="twoShow">
      <!-- 礼卡装 -->
      <div class="j-flex">
        <div class="j-left">
          <img src="@/assets/images/lika.png" alt />
          <div class="icon">礼卡装</div>
        </div>
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data3" :key="item.id">
              <div class="f-flex">
                <div class="j-right" @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 礼盒装 -->
      <div class="j-flex" style="margin-top:0.5rem">
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item  v-for="item of data2" :key="item.id">
              <div class="f-flex">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="j-lihe">
          <img src="@/assets/images/lihe1.png" alt />
          <div class="icon">礼盒装</div>
        </div>
      </div>
    </div>
    <!-- 五对装 -->
    <div v-show="threeShow">
      <!-- 礼卡装 -->
      <div class="j-flex">
        <div class="j-left">
          <img src="@/assets/images/lika.png" alt />
          <div class="icon">礼卡装</div>
        </div>
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data5" :key="item.id">
              <div class="f-flex">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 礼盒装 -->
      <div class="j-flex" style="margin-top:0.5rem">
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data4" :key="item.id">
              <div class="f-flex">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="j-lihe">
          <img src="@/assets/images/lihe1.png" alt />
          <div class="icon">礼盒装</div>
        </div>
      </div>
    </div>
  </div>
  <div class="dock" v-else>
    <div class="M-title1">MIXIETAI·MALL</div>
    <div class="S-title1">觅蟹台大闸蟹·商城</div>
    <div class="d-title1">
      <el-radio-group
        v-model="tabPosition"
        style="margin-bottom: 30px;margin:0 auto;"
        @change="tapShow"
      >
        <el-radio-button one label="left">精品三对装</el-radio-button>
        <el-radio-button two label="middle">豪华四对装</el-radio-button>
        <el-radio-button three label="right">至尊五对装</el-radio-button>
      </el-radio-group>
    </div>
    <div v-show="oneShow">
      <div>
        <div class="icon1">礼卡装</div>
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data1" :key="item.id">
              <div class="f-flex1">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money1">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="icon1">礼盒装</div>
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data0" :key="item.id">
              <div class="f-flex1">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money1">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>



    <div v-show="twoShow">
      <div>
        <div class="icon1">礼卡装</div>
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data3" :key="item.id">
              <div class="f-flex1">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money1">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="icon1">礼盒装</div>
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data2" :key="item.id">
              <div class="f-flex1">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money1">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div v-show="threeShow">
      <div>
        <div class="icon1">礼卡装</div>
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data5" :key="item.id">
              <div class="f-flex1">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money1">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="icon1">礼盒装</div>
        <div class="jiantou" style="width:100%">
          <el-carousel :interval="4000" type='card'>
            <el-carousel-item v-for="item of data4" :key="item.id">
              <div class="f-flex1">
                <div class="j-right"  @click="xieDetail(item.id,item.title)">
                  <div>{{item.title}}</div>
                  <div class="img">
                    <img width="100%" height="100%" :src="item.mealimage" alt />
                  </div>
                  <div class="three">{{item.describe}}</div>
                  <div class="money1">
                    <span>品质价</span>
                    <span>￥</span>
                    <span>{{item.price}}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "DockItem",
  data() {
    return {
      tabPosition: "left",
      crab_threepairs: [],
      crab_luxuryfive: [],
      crab_supremefive: [],
      data0: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      oneShow: false,
      twoShow: false,
      threeShow: false,
    };
  },
  components: {
    vueSeamlessScroll,
  },
  mounted() {
    this.$http.get("api/index/index").then((res) => {
      this.crab_threepairs = res.data.data.crab_threepairs;
      this.data0 = this.crab_threepairs[0].data;
      this.data1 = this.crab_threepairs[1].data;
      this.crab_luxuryfive = res.data.data.crab_luxuryfive;
      this.data2 = this.crab_luxuryfive[0].data;
      this.data3 = this.crab_luxuryfive[1].data;
      this.crab_supremefive = res.data.data.crab_supremefive;
      this.data4 = this.crab_supremefive[0].data;
      this.data5 = this.crab_supremefive[1].data;
    });
    this.oneShow = true;
  },
  methods: {
    tapShow() {
      console.log(this.tabPosition);
      if (this.tabPosition == "left") {
        this.oneShow = true;
        this.twoShow = false;
        this.threeShow = false;
      } else if (this.tabPosition == "middle") {
        this.oneShow = false;
        this.twoShow = true;
        this.threeShow = false;
      } else if (this.tabPosition == "right") {
        this.oneShow = false;
        this.twoShow = false;
        this.threeShow = true;
      }
    },
    xieDetail(id, title) {
      this.$router.push(`/xieDetail?id=${id}&title=${title}`);
    },
  },
};
</script>

<style lang="scss">
.dock {
  text-align: center;
  padding-bottom: 5%;
}
.M-title {
  width: 100%;
  height: 70px;
  font-size: 35px;
  font-family: Helvetica;
  color: rgba(255, 255, 255, 1);
  line-height: 84px;
}
.S-title {
  width: 100%;
  height: 50px;
  font-size: 20px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
}
.d-title {
  margin: 30px 0 20px 0;
}
.j-flex {
  display: flex;
  justify-content: space-around;
  width: 80%;
  margin: 0 auto;
}
.j-left {
  position: relative;
  width: 20%;
  img {
    width: 100%;
    height: 100%;
  }
  .icon {
    position: absolute;
    top: 3%;
    left: 80%;
    font-size: 35px;
    font-family: Helvetica;
    color: rgba(255, 255, 255, 1);
    font-weight: bold;
  }
}
.j-lihe {
  position: relative;
  width: 20%;
  img {
    width: 100%;
    height: 100%;
  }
  .icon {
    position: absolute;
    top: 3%;
    left: 0;
    width: 10px;
    font-size: 35px;
    font-family: Helvetica;
    color: rgba(255, 255, 255, 1);
    font-weight: bold;
  }
}
.j-right {
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  width: 100%;
  flex-shrink: 0;
  cursor: pointer;
  div:first-child {
    width: 90%;
    background: rgba(218, 37, 28, 1);
    border-radius: 7px;
    font-size: 22px;
    font-family: Helvetica;
    color: rgba(255, 255, 255, 1);
    line-height: 30px;
    margin: 10px auto;
  }
  .img {
    font-size: 18px;
    font-family: Helvetica;
    color: rgba(218, 37, 28, 1);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 90%;
    height: 4rem;
    margin: 0 auto;
  }
  .three {
    font-size: 14px;
    padding: 5px;
    font-family: Helvetica;
    color: rgba(218, 37, 28, 1);
    border-radius: 6px;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /*后面的5是设置显示几行*/
  }
  .money {
    display: flex;
    width: 90%;
    margin: 0 auto;
    margin-top: 0.2rem;
    padding-bottom: 0.3rem;
    span:first-child {
      width: 2rem;
      line-height: 1rem;
      font-size: 15px;
      background: #da251c;
      color: #fff;
      border-radius: 10px;
    }
    span:nth-child(2) {
      color: #da251c;
      font-size: 20px;
      margin-top: 0.2rem;
    }
    span:nth-child(3) {
      color: #c30b0a;
      font-size: 20px;
      font-weight: bold;
      margin-top: 0.2rem;
    }
  }
}
.f-flex {
  display: flex;
  width: 36%;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 0.7rem;
}
/* 移动端 */
.M-title1 {
  width: 100%;
  font-size: 25px;
  font-family: Helvetica;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
}
.S-title1 {
  width: 100%;
  height: 10px;
  font-size: 14px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.j-item1 {
  width: 90%;
  margin: 0 auto;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.j-item1 .userImageAllWrapper {
  width: 100%;
  overflow-x: auto;
}
.d-title1 {
  margin: 30px 0 20px 0;
}
.j-left1 {
  width: 45%;
  height: 80%;
  margin-top: 20%;
}
.j-left1 img {
  width: 100%;
  height: 100%;
}
.icon1 {
  left: 80%;
  font-size: 25px;
  font-family: Helvetica;
  color: rgba(255, 255, 255, 1);
  font-weight: bold;
}
.f-flex1{
  width: 100%;
}
.f-flex1 .j-right{
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  margin: 5% 0 0;
  flex-shrink: 0;
  overflow: hidden;
  padding-bottom:2% ;
}
.f-flex1 .j-right > div:nth-of-type(1) {
  width: 90%;
  background: rgba(218, 37, 28, 1);
  border-radius: 7px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  margin: 2% auto;
}
.f-flex1 .j-right > p:nth-of-type(2) {
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(218, 37, 28, 1);
  margin: 4% auto;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.f-flex1 .j-right > p:nth-of-type(3) {
  margin-bottom: 10%;
  margin-top: -8%;
}
.money1{
  margin-top: -5%;
}
.money1 span:nth-child(1){
  font-size: 12px;
  font-family: Helvetica;
  color: rgba(255, 255, 255, 1);
  background: rgba(218, 37, 28, 1);
  border-radius: 6px;
  margin-right: 4px;
  padding: 1%;
}
.money1 > span:nth-child(3) {
  font-size: 14px;
  font-family: Arial-Black, Arial;
  font-weight: 900;
  color: rgba(195, 11, 10, 1);
  line-height: 10px;
}
.money1> span:nth-child(2) {
  color: rgba(195, 11, 10, 1);
  font-weight: bold;
  font-size: 12px;
}
.j-flex1 {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 80%;
  margin: 50px auto;
}
</style>
<style >
.d-title .el-radio-button__inner {
  background: rgba(64, 70, 87, 1);
  font-size: 20px;
}
.d-title  .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 22px 0 0 22px;
}
.d-title  .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 22px 22px 0;
}
.d-title  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff !important;
  color: black;
  border-color:#fff !important;
}
.d-title .el-radio-button__inner {
  color: white;
  width: 215px;
  padding: 15px 0;
  
}
.el-radio-button__inner:hover {
  color: white;
}

.d-title1  .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 22px 0 0 22px;
}
.d-title1  .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 22px 22px 0;
}
.d-title1  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff !important;
  color: black;
  border-color:#fff !important;
}
.d-title1 .el-radio-button__inner {
  background: rgba(64, 70, 87, 1);
  width: 100px;
  padding: 15px 0;
  color: #fff;
}
.d-title1 .el-radio-button__inner {
  font-size: 14px;
}
.el-carousel--horizontal {
  overflow-x: none !important;
}
.el-carousel__mask{
  opacity: -1 !important;
}
.c-content .jiantou .el-carousel__container{
  height: 340px;
}
.el-carousel--horizontal::-webkit-scrollbar{
  display: none;
} 
</style>